import React from "react";

import Heading from "core/Heading";

import { RoyaltiesNoActivityBodyText } from "./styles";

const RoyaltiesNoActivity = () => (
    <>
        <Heading size="lg">No Photo Activity</Heading>
        {/* TODO: uncomment when photographer handbook is ready */}
        {/* <RoyaltiesNoActivityBodyText>
            Learn more about submitting photos and maximizing sales in the
            Photographer Handbook.
        </RoyaltiesNoActivityBodyText> */}
    </>
);

export default RoyaltiesNoActivity;
